export default {
  softBlack: "#3D3636",
  wheat: "#FFF3DB",
  pink: "#ffe6e6",
  darkPink: "#FFCCCC",
  harshPink: "#ff9999",
  white: "#FFFFFF",
};
